import { render, staticRenderFns } from "./CreateKeywordActionCards.vue?vue&type=template&id=36bec96a&scoped=true"
import script from "./CreateKeywordActionCards.vue?vue&type=script&lang=js"
export * from "./CreateKeywordActionCards.vue?vue&type=script&lang=js"
import style0 from "./CreateKeywordActionCards.vue?vue&type=style&index=0&id=36bec96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bec96a",
  null
  
)

export default component.exports